import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border mt-auto">
      <div className="container mx-auto px-4 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <img 
                src="/assets/images/solis-games-logo.png" 
                alt="Solis Games - Premium WebGPU Gaming Platform" 
                className="h-8 w-auto"
              />
            </Link>
            <p className="text-muted-foreground text-sm mb-4">
              Experience unlimited console-quality WebGPU games instantly in your browser. No downloads, no installs required. 
              Premium gaming subscription featuring racing games, action games, and strategy games. 
              Based in Chicago, serving gamers worldwide with cutting-edge browser gaming technology.
            </p>
            <div className="text-muted-foreground text-xs space-y-1">
              <p>© 2025 Solis Interactive Inc. All rights reserved.</p>
              <p>Chicago, Illinois | Premium Browser Gaming Platform</p>
              <p>WebGPU Technology • Instant Gaming • No Downloads</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-foreground font-semibold mb-4">Platform</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/game-library-dashboard" 
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Games
                </Link>
              </li>
              <li>
                <Link 
                  to="/browse" 
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Browse
                </Link>
              </li>
              <li>
                <Link 
                  to="/favorites" 
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Favorites
                </Link>
              </li>
              <li>
                <Link 
                  to="/subscription-management" 
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Subscription
                </Link>
              </li>
              <li>
                <Link
                  to="/developers"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Developers
                </Link>
              </li>
              <li>
                <a
                  href="https://status.solisgames.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Status
                </a>
              </li>
              <li>
                <a
                  href="https://discord.gg/TZdBFBhW"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Discord
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-foreground font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/privacy-policy" 
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms-of-use" 
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link 
                  to="/community-guidelines" 
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Community Guidelines
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-border mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-muted-foreground text-xs mb-4 md:mb-0">
              Solis Interactive Inc. • 1440 W Taylor St PMB 4217 Chicago, Illinois 60607, United States
            </p>
            <div className="flex space-x-4">
              <Link 
                to="/contact" 
                className="text-muted-foreground hover:text-primary text-xs transition-colors"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
